import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastContainer } from 'react-toastify'; 
import { AuthProvider } from './context/AuthContext';

// Create the root element and render the App component
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />  {/* No <Router> here */}
      <ToastContainer />
    </AuthProvider>
  </React.StrictMode>
);
